import { Box, Center } from "@chakra-ui/react";
import React from "react";
import Spinner from "./common/Spinner";

type Props = {
  size?: "sm" | "md" | "lg" | "xl";
};
const FullLoader = ({ size }: Props) => (
  <chakra-scope>
    <Box h="full" w="full">
      <Center h="full" w="full">
        <Spinner
          size={size ?? "xl"}
        />
      </Center>
    </Box>
  </chakra-scope>
);
export default FullLoader;
